import { decimalToHex } from './helpers';

/*****************************************
 * helpers
 *****************************************/

export function clearData2D(size = { width: 2, height: 2 }) {
  const data2D = new Array(size.height);
  for (let i = 0; i < size.height; i++) {
    // all white
    data2D[i] = new Array(size.width).fill('ffffffff');
  }
  data2D.width = size.width;
  data2D.height = size.height;
  return data2D;
}

/**********************************************************
 * algorithms
 ********************************************************* */

// zoom by repeating pixels
export function zoom(src2D, toSize, ratio) {
  const zoomed = clearData2D(toSize);

  for (let i = 0; i < toSize.height; i++) {
    const iSrc = Math.floor(i / ratio);
    for (let j = 0; j < toSize.width; j++) {
      const jSrc = Math.floor(j / ratio);
      zoomed[i][j] = src2D[iSrc][jSrc];
    }
  }
  return zoomed;
}

export function bilinear(src, dest, scale) {
  // c.f.: wikipedia english article on bilinear interpolation
  // taking the unit square, the inner loop looks like this
  // note: there's a function call inside the double loop to this one
  // maybe a performance killer, optimize this whole code as you need

  function inner(f00, f10, f01, f11, x, y) {
    var un_x = 1.0 - x;
    var un_y = 1.0 - y;
    return f00 * un_x * un_y + f10 * x * un_y + f01 * un_x * y + f11 * x * y;
  }
  var i, j;
  var iyv, iy0, iy1, ixv, ix0, ix1;

  var dx, dy;
  var r, g, b, a;

  for (i = 0; i < dest.height; ++i) {
    iyv = i / scale;
    iy0 = Math.floor(iyv);

    // Math.ceil can go over bounds
    iy1 = Math.ceil(iyv) > src.height - 1 ? src.height - 1 : Math.ceil(iyv);

    // ix0 = -1;
    for (j = 0; j < dest.width; ++j) {
      ixv = j / scale;
      ix0 = Math.floor(ixv);
      // Math.ceil can go over bounds
      ix1 = Math.ceil(ixv) > src.width - 1 ? src.width - 1 : Math.ceil(ixv);

      // overall coordinates to unit square
      dx = ixv - ix0;
      dy = iyv - iy0;
      // I let the r, g, b, a on purpose for debugging
      r = inner(
        parseInt(src[iy0][ix0].slice(0, 2), 16),
        parseInt(src[iy0][ix1].slice(0, 2), 16),
        parseInt(src[iy1][ix0].slice(0, 2), 16),
        parseInt(src[iy1][ix1].slice(0, 2), 16),
        dx,
        dy
      );
      g = inner(
        parseInt(src[iy0][ix0].slice(2, 4), 16),
        parseInt(src[iy0][ix1].slice(2, 4), 16),
        parseInt(src[iy1][ix0].slice(2, 4), 16),
        parseInt(src[iy1][ix1].slice(2, 4), 16),
        dx,
        dy
      );
      b = inner(
        parseInt(src[iy0][ix0].slice(4, 6), 16),
        parseInt(src[iy0][ix1].slice(4, 6), 16),
        parseInt(src[iy1][ix0].slice(4, 6), 16),
        parseInt(src[iy1][ix1].slice(4, 6), 16),
        dx,
        dy
      );
      a = inner(
        parseInt(src[iy0][ix0].slice(6, 8), 16),
        parseInt(src[iy0][ix1].slice(6, 8), 16),
        parseInt(src[iy1][ix0].slice(6, 8), 16),
        parseInt(src[iy1][ix1].slice(6, 8), 16),
        dx,
        dy
      );

      dest[i][j] =
        decimalToHex(r) + decimalToHex(g) + decimalToHex(b) + decimalToHex(a);
    }
  }
}
